var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_group"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"checked":_vm.normalizedValue,"disabled":_vm.disabled,"name":_vm.name,"switch":""},on:{"change":_vm.handleChange}},[_vm._v("\n    "+_vm._s(!_vm.hideTextValue ? _vm.value ? 'Yes' : 'No' : '')+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }